import { Check } from "lucide-react";

const features = [
  { title: "ISO & MSME Certified", desc: "Recognized for quality and compliance." },
  { title: "AI-Powered Screening", desc: "Faster, smarter candidate matching." },
  { title: "Pan-India Network", desc: "20+ cities, active talent pools." },
  { title: "Dedicated Account Manager", desc: "Single point of contact for every client." },
  { title: "Bulk Hiring Capability", desc: "Scale from 10 to 1,000+ hires." },
  { title: "Sector Expertise", desc: "IT, BFSI, Manufacturing and more." },
  { title: "Fast Turnaround", desc: "Average time-to-fill under 10 working days." },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 lg:py-28 bg-secondary/40" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">Why WorkingBees</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            We bring the right blend of{" "}
            <span className="text-bee-teal">tech, people, and process</span>.
          </h2>
          <p className="mt-5 text-base lg:text-lg text-muted-foreground max-w-xl">
            What makes us different isn&apos;t just our database — it&apos;s how we work alongside you, like an
            extension of your team.
          </p>
          <ul className="mt-8 space-y-3">
            {features.map((f, i) => (
              <li key={f.title} className="flex items-start gap-3" data-testid={`why-feature-${i}`}>
                <span className="h-6 w-6 rounded-md bg-bee-teal text-white inline-flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <div>
                  <div className="font-display font-bold">{f.title}</div>
                  <div className="text-sm text-muted-foreground">{f.desc}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/3] border border-border shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1000&auto=format&fit=crop&q=80"
              alt="Team meeting at WorkingBees"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-bee-teal/60 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 grid grid-cols-3 gap-3">
              <div className="rounded-xl bg-white/95 backdrop-blur p-3 text-center">
                <div className="font-display text-2xl font-bold text-bee-teal">10d</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Avg. fill</div>
              </div>
              <div className="rounded-xl bg-white/95 backdrop-blur p-3 text-center">
                <div className="font-display text-2xl font-bold text-bee-teal">95%</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Quality fit</div>
              </div>
              <div className="rounded-xl bg-white/95 backdrop-blur p-3 text-center">
                <div className="font-display text-2xl font-bold text-bee-teal">24×7</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
